var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 20.4053C4.16602 13.1432 4.16602 9.51213 6.25288 7.25607C8.33975 5 11.6985 5 18.416 5H21.5827C28.3002 5 31.659 5 33.7458 7.25607C35.8327 9.51213 35.8327 13.1432 35.8327 20.4053V21.2613C35.8327 28.5235 35.8327 32.1545 33.7458 34.4107C31.659 36.6667 28.3002 36.6667 21.5827 36.6667H18.416C11.6985 36.6667 8.33975 36.6667 6.25288 34.4107C4.16602 32.1545 4.16602 28.5235 4.16602 21.2613V20.4053Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 28.3334L16.6667 22.2454C16.6667 21.9259 16.4388 21.6667 16.1576 21.6667H15M22.7162 28.3334L24.9737 22.2487C25.0792 21.9642 24.8547 21.6667 24.5345 21.6667H21.6667",
    stroke: "#227451",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333H30",
    stroke: "#227451",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.33325V6.66659M10 3.33325V6.66659",
    stroke: "#227451",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.05a449cc82841f203ba7cc3052058e62.svg";
export { ForwardRef as ReactComponent };